import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';



export interface DialogData {
    custId: string;
    hubId: string;
    config: object;
}



@Component({
    selector: 'hub-status-dialog',
    templateUrl: 'hubStatus.component.html',
})
export class HubStatusDialog {

    

    initialData = {
        userOtp: '',
        reason: '',
        requiredAction: '',
        eGluAdminPin: '',
        lockHub: false,
        blockHubFunctionality: false,
        custId: this.data.custId,
        hubId: this.data.hubId
    }


    constructor(private http: HttpClient, private env: EnvService, private router: Router, private _snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<HubStatusDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) { }


    ngOnInit(): void {
        // console.log(this.data)
        this.initialData.blockHubFunctionality = this.data.config['blockHubFunctionality']
        this.initialData.lockHub = this.data.config['lockHub']
        this.initialData.reason = this.data.config['reason']
        this.initialData.requiredAction = this.data.config['requiredAction']
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    showPassword = false;

    getInputType() {
        if (this.showPassword) {
            return 'text';
        }
        return 'password';
    }

    toggleShowPassword() {
        this.showPassword = !this.showPassword;
    }

    openSnackBar(msg) {
        this._snackBar.open(msg, '', {
            duration: 2000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
        });
    }

    sendEmail() {
        this.http.post(this.env.apiUrl + "/api/user/sendEmailWithOtp", { custId: this.data.custId })
            .subscribe(response => {
                console.log(response);
                this.openSnackBar(response['message']);
            }, err => {
                console.log(err);
                this.openSnackBar("Failed to send email.");
            })
    }


    verifyAndUpdateStatus(data) {
        console.log(data)
        this.http.post(this.env.apiUrl + "/api/hubConfig/updateHubStatus", data)
            .subscribe(response => {
                console.log(response);
                this.openSnackBar(response['message']);
                this.dialogRef.close();
                setTimeout(() => {
                    window.location.reload();
                }, 1250);
            }, err => {
                console.log(err);
                this.openSnackBar("Failed to update.");
            })
    }

}